import React from "react";
import {
  Box,
  Flex,
  Text,
  useTheme,
  Image,
  Icon,
  useDisclosure,
  Skeleton,
} from "@chakra-ui/react";
import { Theme } from "../../theme";
import Cookies from "js-cookie";
import getAxios from "../../hooks/useAxios";
import { MdDeleteForever, MdOutlineModeEdit } from "react-icons/md";
import StatusConfirmationModal from "../../components/StatusConfirmModal";
import Nodata from "../../components/Nodata";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

function Index() {
  const theme = useTheme<Theme>();
  const axios = getAxios();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const access_token = Cookies.get("x-admin-auth");
  const [ads, setAds] = React.useState<any>([]);
  const [adIdToDelete, setAdIdToDelete] = React.useState<any>();
  const [isDataFetching, setIsDataFetching] = React.useState(true);

  const getAllAds = async () => {
    setIsDataFetching(true);
    try {
      const res = await axios.get(`/advertisements`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      const sortedAds = [...res.data?.data].sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
      );

      setAds(sortedAds);
    } catch (error) {
      console.log("error listing ad", error);
    } finally {
      setIsDataFetching(false);
    }
  };

  const deleteAd = async () => {
    try {
      const res = await axios.delete(`/advertisements/${adIdToDelete}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("delete", res.data);
      getAllAds();
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditButtonClick = (val: string) => {
    navigate({
      pathname: "/advertisement/edit",
      search: `?id=${val}`,
    });
  };

  React.useEffect(() => {
    getAllAds();
  }, []);

  const getAdStatus = (status: string, endAt: string) => {
    const isEndDatePassed = new Date(endAt).getTime() <= Date.now();

    if (status === "running" && !isEndDatePassed) {
      return "Running";
    }

    return "Paused";
  };

  function getScreenName(place: string) {
    switch (place) {
      case "home":
        return "Home Screen";
      case "search":
        return "Search Screen";
      case "onprogress":
        return "Ride Ongoing";
      case "complete":
        return "Ride Complete";
      default:
        return "Unknown Screen";
    }
  }

  const viewUsers = (val: string) => {
    navigate({
      pathname: "/advertisement/view-user-list",
      search: `?id=${val}`,
    });
  };

  // if (ads.length === 0)
  //   return (
  //     <Box
  //       style={{
  //         padding: "2rem",
  //       }}
  //     >
  //       <Nodata heading="No Advertisements Listed" />
  //     </Box>
  //   );

  return (
    <Box
      style={{
        padding: "2rem",
      }}
    >
      <Text
        sx={{
          fontSize: theme.fontSizes.subHeading1,
          marginBottom: theme.space["3xl"],
        }}
      >
        All Advertisements
      </Text>

      <Skeleton isLoaded={isDataFetching ? false : true} minHeight={"20rem"}>
        {ads && ads.length !== 0 ? (
          <table>
            <thead>
              <tr>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Thumbnail
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Title
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Status
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Clicks
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Running Screen
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Start Date
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    End Date
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Update
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Delete
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    View
                  </Text>
                </th>
              </tr>
            </thead>
            <tbody>
              {ads.map((item: any, index: number) => (
                <tr key={index}>
                  <td>
                    <GetImages data={item.img} />
                    {/*  */}
                  </td>
                  <td>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading2,
                      }}
                    >
                      {item.title}
                    </Text>
                  </td>
                  <td>
                    <Flex
                      justifyContent={"center"}
                      alignItems={"center"}
                      background={
                        getAdStatus(item.status, item.end_at) === "Running"
                          ? theme.colors.success
                          : theme.colors.error
                      }
                      borderRadius="0.25rem"
                    >
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.subHeading2,
                          color: "#FFFFFF",
                        }}
                      >
                        {getAdStatus(item.status, item.end_at)}
                      </Text>
                    </Flex>
                  </td>
                  <td>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading2,
                      }}
                    >
                      {item?.click_count || 0}
                    </Text>
                  </td>
                  <td>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading2,
                      }}
                    >
                      {getScreenName(item.place)}
                    </Text>
                  </td>
                  <td>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading2,
                      }}
                    >
                      {new Date(item.start_at).toLocaleDateString("en-IN")}
                    </Text>
                  </td>
                  <td>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading2,
                      }}
                    >
                      {new Date(item.end_at).toLocaleDateString("en-IN")}
                    </Text>
                  </td>
                  <td>
                    <Flex
                      sx={{
                        justifyContent: "center",
                        // background: isActive ? theme.colors.bg.main : 'transparent',
                        alignItems: "center",
                        height: "2.8rem",
                        width: "2.8rem",
                        borderRadius: "0.25rem",
                        // _hover: isActive ? { backgroundColor: theme.colors.bg.main } : { backgroundColor: theme.colors.bg.paper },
                      }}
                    >
                      <Icon
                        as={MdOutlineModeEdit}
                        width={6}
                        height={6}
                        color={theme.colors.primary.main}
                        cursor="pointer"
                        onClick={() => handleEditButtonClick(item.id)}
                      />
                    </Flex>
                  </td>
                  <td>
                    <Flex
                      sx={{
                        justifyContent: "center",
                        // background: isActive ? theme.colors.bg.main : 'transparent',
                        alignItems: "center",
                        height: "2.8rem",
                        width: "2.8rem",
                        borderRadius: "0.25rem",
                        // _hover: isActive ? { backgroundColor: theme.colors.bg.main } : { backgroundColor: theme.colors.bg.paper },
                      }}
                      onClick={() => {
                        onOpen();
                        setAdIdToDelete(item.id);
                      }}
                    >
                      <Icon
                        as={MdDeleteForever}
                        width={6}
                        height={6}
                        color={theme.colors.primary.main}
                        cursor="pointer"
                      />
                    </Flex>
                  </td>
                  <td>
                    <Flex
                      sx={{
                        justifyContent: "center",
                        // background: isActive ? theme.colors.bg.main : 'transparent',
                        alignItems: "center",
                        height: "2.8rem",
                        width: "2.8rem",
                        borderRadius: "0.25rem",
                        // _hover: isActive ? { backgroundColor: theme.colors.bg.main } : { backgroundColor: theme.colors.bg.paper },
                      }}
                      onClick={() => viewUsers(item.id)}
                    >
                      <Icon
                        as={FaArrowRight}
                        width={5}
                        height={5}
                        color={theme.colors.primary.main}
                        cursor="pointer"
                      />
                    </Flex>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <Box
            style={{
              padding: "2rem",
            }}
          >
            <Nodata heading="No Advertisements Listed" />
          </Box>
        )}
      </Skeleton>
      <StatusConfirmationModal
        heading="Are you sure want to delete ?"
        isOpen={isOpen}
        onClose={onClose}
        handleApiCall={() => deleteAd()}
      ></StatusConfirmationModal>
    </Box>
  );
}

export default Index;

function GetImages({ data }: any) {
  const axios = getAxios();
  const token = Cookies.get("x-admin-auth");
  const [imageLink, setImageLink] = React.useState<string>();
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (data) {
      setLoading(true);
      (async () => {
        const img = await getImageLink(data);
        setImageLink(img);
        setLoading(false);
      })();
    }
  }, [data]);

  function arrayBufferToBase64(buffer: any) {
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.length;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }

  const getImageLink = async (url: string) => {
    try {
      const res = await axios.get(`uploads/${url}?token=${token}`, {
        responseType: "arraybuffer",
      });
      const buffer = res.data;
      let base64String = arrayBufferToBase64(buffer);
      let dataUri = "data:image/jpeg;base64," + base64String;
      return dataUri;
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      {loading ? (
        <Skeleton
          isLoaded={false}
          style={{ width: "4rem", aspectRatio: 4 / 3 }}
        />
      ) : (
        <Image
          src={imageLink}
          alt="No Images"
          aspectRatio={4 / 3}
          width="4rem"
        />
      )}
    </>
  );
}
